import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class RaceLiveQuestionStore extends LocalModel {
    constructor() {
        super('raceLiveQuestion', {
            namePlural: 'raceLiveQuestions',
            namePluralReal: 'racelivequestions',
            sort: '-createdDate',
            limit: 50,
            api: {
                search: {
                    url: '/api/racelivequestions/',
                    params: {
                        limit: 50,
                        sort: '-createdDate',
                    },
                },
                load: {
                    url: '/api/racelivequestions/',
                    params: {},
                },
                save: {
                    url: '/api/racelivequestions/',
                    params: {},
                },
                delete: {
                    url: '/api/racelivequestions/',
                    params: {},
                },
            },
        });
    }

    @observable newRaceLiveQuestion = {};

    @observable raceLiveQuestion = {};

    @observable raceLiveQuestions = [];
}

const store = new RaceLiveQuestionStore();
export default store;
